import React from "react";
import { FileText, TrendingUp, Shield, Target } from "lucide-react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./WhyBSquare.css";

const WhyBSquare = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation({ threshold: 0.1 });

  const pillars = [
    {
      title: "Clear, structured guidance",
      icon: FileText,
    },
    {
      title: "Risk-aware and forward-looking",
      icon: TrendingUp,
    },
    {
      title: "Focused on long-term protection, not transactions",
      icon: Shield,
    },
    {
      title: "Tailored to individual circumstances",
      icon: Target,
    },
  ];

  return (
    <section className="why-bsquare">
      <div className="why-bsquare-container">
        <div ref={headerRef} className={`why-bsquare-header ${headerVisible ? "animate-in" : ""}`}>
          <h2 className="why-bsquare-title">Why Clients Choose BSquare Financial</h2>
          <p className="why-bsquare-description">
            BSquare Financial provides thoughtful, outcomes-focused guidance around insurance and financial protection. Our work centers on clarity, efficiency, and helping clients make informed decisions—particularly during key financial moments such as mortgage renewal, career growth, or practice expansion.
          </p>
        </div>
        <div ref={contentRef} className={`why-bsquare-pillars ${contentVisible ? "animate-in" : ""}`}>
          {pillars.map((pillar, index) => {
            const IconComponent = pillar.icon;
            return (
              <div key={index} className="pillar-card">
                <div className="pillar-icon">
                  <IconComponent size={32} strokeWidth={1.5} />
                </div>
                <h3 className="pillar-title">{pillar.title}</h3>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyBSquare;
